import { useEffect, useState } from "react";
import { AMAZON_LINKS, detectCountry, resolveAmazonLink } from "@/lib/amazon";

// Returns the Amazon link matching the visitor's country, plus their detected
// country code. Falls back to the default link while geo lookup is pending.
export function useAmazonLink() {
  const [country, setCountry] = useState(null);
  const [link, setLink] = useState(AMAZON_LINKS.default);

  useEffect(() => {
    let alive = true;
    (async () => {
      const cc = await detectCountry();
      if (!alive) return;
      setCountry(cc);
      setLink(resolveAmazonLink(cc));
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { link, country };
}
